// extracted by mini-css-extract-plugin
export var block = "recipe-collections-module--block--2-h6U";
export var list = "recipe-collections-module--list--jwoSL";
export var link = "recipe-collections-module--link--3tsea";